import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';
import { ContentPipeService } from '@services/content-pipe/content-pipe.service';
import { HelperService } from '@services/helper/helper.service';

@Pipe({
    name: 'contentTicker',
    standalone: false
})
export class TickerPipe implements PipeTransform {
  constructor(private contentPipeService: ContentPipeService) {
  }

  transform(entry: any): any {
    if (!entry) {
      return null;
    }

    return {
      color: entry?.content?.color || entry?.widget?.detail?.color || '#FFFFFF', text: entry?.content?.textContent?.replace(/&nbsp;/gi, ' ') || '',
      background: entry?.content?.backgroundColor || entry?.widget?.detail?.backgroundColor || '#111111', image: this.contentPipeService.getMedia(entry)?.[0], contentType: 'ticker',
      title: entry.widget?.translations?.[0]?.title || entry.app?.translations?.[0]?.appTitle, subtitle: entry.widget?.translations?.[0]?.subtitle
    } as any
  }
}
